// extracted by mini-css-extract-plugin
export var card = "_k4-5";
export var cardSelected = "_k4-4";
export var image = "_k4-3";
export var modal = "_k4-0";
export var modalContent = "_k4-1";
export var table = "_k4-2";